import { render, staticRenderFns } from "./register-result.vue?vue&type=template&id=468ab2b7&scoped=true&"
import script from "./register-result.vue?vue&type=script&lang=js&"
export * from "./register-result.vue?vue&type=script&lang=js&"
import style0 from "./register-result.vue?vue&type=style&index=0&id=468ab2b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468ab2b7",
  null
  
)

export default component.exports